const config = {
    baseUrl: '//yt.iyunto.net',
    vendorUrl: '//yt.iyunto.net/vendor',
    groupUrl: '//yt.iyunto.net/group'
}

export default config
